export const STATUS = [
    {
        label: 'All',
        value: ''
    },
    {
        label: 'Chờ book',
        value: '0'
    },
    {
        label: 'Hoạt động',
        value: '1'
    },
    {
        label: 'Chờ check khóa số',
        value: '2'
    },
    {
        label: 'Bị khóa',
        value: '3'
    },
    {
        label: 'Hủy',
        value: '9'
    },
    {
        label: 'Chờ check thông luồng',
        value: '-1'
    },
    {
        label: 'Thu hồi',
        value: '8'
    },
    {
        label: 'Admin tạm chặn',
        value: '3'
    },
]
export const STATUS_LOCK = [
    {
        label: 'All',
        value: ''
    },
    {
        label: 'Hướng VTL',
        value: '1'
    },
    {
        label: 'Hướng MBF',
        value: '2'
    },
    {
        label: 'Hướng VNA',
        value: '3'
    }
]
